import { render, staticRenderFns } from "./LoginMethod.vue?vue&type=template&id=2f2f612a&"
import script from "./LoginMethod.vue?vue&type=script&lang=js&"
export * from "./LoginMethod.vue?vue&type=script&lang=js&"
import style0 from "./LoginMethod.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LoginMethod.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports